import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { IconButton } from 'react-toolbox/lib/button'

import notifyHoc from 'containers/App/Notification/Notify'
import CollapseIcon from './CollapseIcon'

import styles from './styles.scss'

const NotifyButton = notifyHoc(IconButton)

const CollapseIconButton = (props) => {
  const { collapse, onClick, ...rest } = props
  return (
    <NotifyButton {...rest} style={{marginLeft: 'auto'}} onClick={onClick}>
      <CollapseIcon collapse={collapse} {...rest}/>
    </NotifyButton>
  )
}

CollapseIconButton.propTypes = {
  collapse: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
}

CollapseIconButton.defaultProps = {
  collapse: false
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(CollapseIconButton)
